import type { Assignment } from '../api/generated/Assignment'
import type { Shift } from '../api/generated/Shift'

/** Recounts each shift's volunteers from the full list of the event's assignments. */
export function withCounts(shifts: Shift[], assignments: Assignment[]): Shift[] {
  const count = (shiftId: string, status: Assignment['status']) =>
    assignments.filter((a) => a.shift_id === shiftId && a.status === status).length
  return shifts.map((shift) => ({
    ...shift,
    accepted_volunteers: count(shift.id, 'accepted'),
  }))
}
